// eslint-disable-next-line no-shadow
export enum ToastType {
  'Error' = 'Error',
  'Warning' = 'Warning',
  'Success' = 'Success',
  'Alert' = 'Alert',
}
